import { Button } from "semantic-ui-react";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CloneButton = ({ foi }) => {

    const navigate = useNavigate();
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson || parentResourceDetail?.resourceJson;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const cloneText = "Clone " + (resourceJson?.resourceType || "");

    return <Button className="formButton navigationButton"
        style={{ color: "#000000", width: "97%", margin: "0px" }}
        content={cloneText}
        onClick={() => {
            let redirectUrl = "/create";
            if (resourceJson.resourceType) {
                redirectUrl += "/" + resourceJson.resourceType;
            }
            redirectUrl += "/" + resourceJson.id;
            navigate(redirectUrl)
        }}
        disabled={viewingOlderVersion} />;
};

export default CloneButton;